import {ILayerState} from "../store/types";

export function layerIsVisible (layerState: ILayerState, layerId: string) {
    return layerState[layerId] && layerState[layerId].visibility === 'visible';
}
